export default defineNuxtRouteMiddleware((to) => {
  const { signedIn } = useAuth()

  if (
    to.meta.requiredAuthStatus === 'authenticated' &&
    !signedIn.value &&
    to.path !== BEFORE_SIGN_IN_PATH
  ) {
    return {
      path: BEFORE_SIGN_IN_PATH,
      query: { to: encodeURIComponent(to.fullPath) },
    }
  }

  if (to.meta.requiredAuthStatus === 'unauthenticated' && signedIn.value) {
    const path = to.query.to
      ? decodeURIComponent(queryValueToString(to.query.to) || '')
      : AFTER_SIGN_IN_PATH
    return path
  }
})
